import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FormAutosuggest from '@adv-mt/mt-form-autosuggest'
import FormFieldTooltip from '@adv-mt/mt-form-field-tooltip'

const DEFAULT_LABEL = 'COMMON.VERSION'

const mapOptions = items =>
  items.filter(item => typeof item.text === 'string').map(({value: id, text: label}) => ({id, label}))

const FormVersion = ({
  initialSearch,
  label = DEFAULT_LABEL,
  placeholder = DEFAULT_LABEL,
  value,
  onChange,
  tooltipContent,
  withLabel = true
}) => {
  const {i18n, domain} = useContext(Context)
  const [versions, setVersions] = useState([])
  const [inputError, setInputError] = useState(false)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {VEHICLE_SPECS_CONTEXT} = config.get('vehicles')
  const {model: {id: modelId} = {}, categoryId} = initialSearch

  const hasInputError = Boolean(inputError)

  const handleOnChange = (e, {value}) =>
    onChange(e, {
      field: FILTER_NAMES.VERSION,
      value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.VERSION]
    })

  const handleInputError = () => setInputError(true)

  useEffect(() => {
    if (!modelId || !categoryId) return

    domain
      .get('get_specs_vehicles_use_case')
      .execute({
        nextField: VEHICLE_SPECS_CONTEXT.VERSION,
        params: {modelId, section1Id: categoryId}
      })
      .then(([error, response]) => {
        if (error) return

        const {items} = response
        const versionsOptions = mapOptions(items)
        setVersions(versionsOptions)
      })
  }, [modelId, categoryId, domain, VEHICLE_SPECS_CONTEXT.VERSION])

  return (
    <div className="mt-FormVersion">
      <FormAutosuggest
        id={FILTER_NAMES.VERSION}
        label={withLabel && i18n.t(label)}
        onChange={handleOnChange}
        onError={handleInputError}
        options={versions}
        placeholder={i18n.t(placeholder)}
        value={value}
      />
      {tooltipContent && !hasInputError ? (
        <div className="mt-FormVersion-info">
          <FormFieldTooltip content={tooltipContent} />
        </div>
      ) : null}
    </div>
  )
}

FormVersion.displayName = 'FormVersion'
FormVersion.propTypes = {
  initialSearch: PropTypes.shape({
    categoryId: PropTypes.number,
    model: PropTypes.shape({
      id: PropTypes.number
    })
  }),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  withLabel: PropTypes.bool
}

export default FormVersion
